exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n  margin: 0;\n  padding: 0;\n  font-family: \"Montserrat\", sans-serif;\n  background-color: #121212;\n  color: #eee;\n  word-wrap: break-word; }\n\n* {\n  -webkit-overflow-scrolling: touch; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/index.scss
// module id = 1150
// module chunks = 0